export const states = [
  'Alabama',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const incomeRanges = [
  '$50,000-$100,000',
  '$100,000-$150,000',
  '$150,000-$250,000',
  '$250,000-$500,000',
  '$500,000-$750,000',
  '$750,000-$1M',
  'Greater than $1M',
];

export const totalBudgets = [
  '$25,000',
  '$50,000',
  '$75,000',
  '$100,000',
  '$150,000',
  '$200,000',
  '$250,000',
  '$300,000',
  '$350,000',
  '$400,000',
  '$450,000',
  '$500,000',
  '$550,000',
  '$600,000',
  '$650,000',
  '$700,000',
  '$750,000',
  '$800,000',
  '$850,000',
  '$900,000',
  '$950,000',
  '$1,000,000',
  '$1,500,000',
  '$2,000,000',
  '$2,500,000',
  '$3,000,000',
  '$3,500,000',
  '$4,000,000',
  '$4,500,000',
  '$5,000,000',
];

export const creditScores = [
  '800-850',
  '740-799',
  '670-739',
  '580-669',
  '300-579',
];

export const homeStyles = [
  'Contemporary',
  'Modern',
  'Cape',
  'Ranch',
  'Traditional',
  'Farmhouse',
  'British West Indies',
  'Key West',
  'Tiny',
  'ADU',
  'Other',
];
